import React from "react"
import Image from "gatsby-plugin-sanity-image"

import { StandardBlockWrapper } from "./standardBlockWrapper"
import { PortableTextBlock } from "../sanity/portableTextBlock"
import { ArrowLinkButton } from "../ui/links"

const ProductRange = ({
  padding,
  rangeImage,
  rangeIcon,
  rangeBg,
  collection,
  _rawDescription,
  layout,
}) => {
  const textClasses =
    layout === "right"
      ? "md:col-start-3 md:col-end-8"
      : "md:col-start-7 lg:col-start-8 "
  const imageClasses = layout === "right" ? "md:col-start-10" : "md:col-end-6"
  const whiteClasses =
    layout === "right" ? "col-start-1 col-end-9" : "col-start-7 col-end-15"
  const bgClasses =
    layout === "right" ? "col-start-2 col-end-11" : "col-start-1 col-end-10"
  const rangeClasses =
    layout === "right" ? "col-start-1 col-end-10" : "col-start-2 col-end-11"
  const iconClasses =
    layout === "right" ? "col-start-6 col-end-8" : "col-start-12 col-end-14"
  return (
    <StandardBlockWrapper
      padding={padding}
      className="grid grid-cols-14 gap-y-8 lg:grid-rows-prodFeature"
    >
      {/* Left */}
      <div
        className={`col-start-2 col-end-14 lg:row-start-1 lg:row-end-3 ${imageClasses}`}
      >
        {/* Range Shot */}
        <div className="grid grid-cols-10">
          {rangeImage && (
            <div className={`row-start-1 relative z-10 ${rangeClasses}`}>
              <div className="aspect-w-3 aspect-h-4 relative">
                <Image
                  {...rangeImage}
                  width="1400"
                  className="w-full h-full absolute top-0 left-0 object-cover"
                />
              </div>
            </div>
          )}
          {rangeBg && (
            <div className={`row-start-1 mt-6 lg:mt-20 ${bgClasses}`}>
              <div className="aspect-w-3 aspect-h-4 relative">
                <Image
                  {...rangeBg}
                  width="1400"
                  className="w-full h-full absolute top-0 left-0 object-cover"
                />
              </div>
            </div>
          )}
        </div>
        {/* Product background */}
      </div>
      {/* white BG */}
      <span
        className={`bg-white row-start-2 hidden lg:block ${whiteClasses}`}
      />
      {/* Guarantee */}
      <div className={`hidden lg:block ${iconClasses}`}>
        <div className="w-40 mx-auto">
          {rangeIcon && <Image {...rangeIcon} />}
        </div>
      </div>
      {/* Right */}
      <div
        className={`col-start-2 col-end-13 lg:row-start-2 lg:py-48 ${textClasses}`}
      >
        <div className="prose md:prose-lg">
          <PortableTextBlock text={_rawDescription} />
          {collection && (
            <ArrowLinkButton page={collection} linkText="Shop Now" />
          )}
        </div>
      </div>
    </StandardBlockWrapper>
  )
}

export default ProductRange
